<script setup lang="ts">
import { CloseIcon } from '@glow/shared/components/icons';
import { formatPrice } from '@glow/shared/utils/format';
import { type FragmentType, graphql } from '@/gql';
import { useRoutes } from '@glow/shared/lib/routes';

const workPlaceFragment = graphql(/* GraphQL */ `
  fragment CartService_MasterWorkPlaceFragment on MasterWorkPlace {
    id
    city {
      id
      slug
    }
    master {
      id
      slug
    }
  }
`);

const cartServiceFragment = graphql(/* GraphQL */ `
  fragment CartService_CartServiceFragment on CartService {
    id
    partnerService {
      id
      price
      service {
        id
        slug
        name
      }
    }
  }
`);

const props = defineProps<{
  cartService: FragmentType<typeof cartServiceFragment>;
  workPlace: FragmentType<typeof workPlaceFragment>;
}>();
const emit = defineEmits<{
  (e: 'remove'): void;
}>();

const workPlace = useFragmentData(workPlaceFragment, () => props.workPlace);
const cartService = useFragmentData(
  cartServiceFragment,
  () => props.cartService
);
const { getUrl } = useRoutes();
const { staticUrl } = useRuntimeConfig().public;
const parameterGroups = computed(() => []);

const link = computed(() =>
  getUrl('partnerService', {
    partnerType: 'master',
    partnerSlug: workPlace.value.master.slug,
    service: cartService.value.partnerService.service.slug,
    city: workPlace.value.city.slug,
  })
);

// const parameterGroups = computed(() =>
//   props.cartService.parameterGroups.map((group) => {
//     const values = group.parameters
//       .map((parameter) => parameter.name)
//       .join(', ');
//     return { id: group.id, text: `${group.name}: ${values}` };
//   })
// );
function remove() {
  emit('remove');
}
</script>

<template>
  <div class="cart-service">
    <NuxtImg
      class="cart-service__image"
      :width="44"
      :height="44"
      :src="`${staticUrl}/images/services/${cartService.partnerService.service.id}.jpg`"
    />
    <NuxtLink class="cart-service__content" :to="link">
      <div class="cart-service__title">
        {{ cartService.partnerService.service.name }}
      </div>
      <!-- <div -->
      <!--   v-for="group in parameterGroups" -->
      <!--   :key="group.id" -->
      <!--   class="cart-service__parameter-group" -->
      <!-- > -->
      <!--   {{ group.text }} -->
      <!-- </div> -->
      <div class="cart-service__price">
        {{ formatPrice(cartService.partnerService.price) }}
      </div>
    </NuxtLink>
    <AppButton variant="link" :icon-end="CloseIcon" @click="remove" />
  </div>
</template>

<style scoped lang="scss">
.cart-service {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  &__image {
    border-radius: 8px;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 16px;
    color: var(--app-color-black);
  }

  &__title {
    font-weight: 700;
  }

  &__parameter-group {
    color: var(--app-color-black-secondary);
  }

  &__price {
    font-weight: 700;
    font-size: 16px;
  }
}
</style>
